import React from 'react';
import './header.css';

const Header = () => {
    return (
    <div id="eThS">
        <input type="radio" name="eThP" id="eThPa" checked />
        <input type="radio" name="eThP" id="eThPr" />            
         <input type="radio" name="eTh" id="eTpa" />
        <input type="radio" name="eTh" id="eThE" />
        <input type="radio" name="eTh" id="eThB" />        
        <input type="radio" name="eTh" id="eThX" checked/>
        <ul id="eTh-top" className="T">
            <li className="hPa">                     <a href="https://www.sfr.fr/" data-hi="0">Particuliers</a>                 </li>                 <label htmlFor="eThPa"></label>
            <li className="hPr">                     <a href="https://www.sfr.fr/pro/" data-hi="0">Professionnels</a>
            </li>                 <label htmlFor="eThPr"></label>                 <form target="_top" action="https://www.sfr.fr/recherche/mixte" noValidate="" className="i-amphtml-form">                     <input name="q" type="text" placeholder="Rechercher dans sfr.fr" />                 </form>                    <span>                     {/* <input type="checkbox" id="eThP"/> */}
                <li style={{ visibility: "visible", backgroundImage: `url("https://static.s-sfr.fr/assets/pictos/applications_40_noir.svg")` }}>                         <label htmlFor="eThP"><p>Apps et services</p></label>                     </li>                     <div>                         <ul>
                    <li style={{ visibility: "visible", backgroundImage: `url("https://static.s-sfr.fr/assets/pictos/Actus_40_rouge.svg")` }}>                                 <a href="https://actus.sfr.fr/">SFR Actus</a>                             </li>
                    <li style={{ visibility: "visible", backgroundImage: `url("https://static.s-sfr.fr/assets/pictos/tv_8_40_rouge.svg")` }}>                                 <a href="https://tv.sfr.fr/">TV sur PC</a>
                    </li>                             <li style={{ visibility: "visible", backgroundImage: `url("https://static.s-sfr.fr/assets/pictos/cloud_40_rouge.svg")` }}>                                 <a href="https://www.sfrcloud.sfr.fr/">SFR Cloud</a>
                    </li>                             <li style={{ visibility: "visible", backgroundImage: `url("https://static.s-sfr.fr/assets/pictos/accueil_40_rouge.svg)` }}>                                 <a href="https://home.sfr.fr/" data-hi="home@|home.boutique@">SFR Home</a>
                    </li>                         </ul>                     </div>
                <li style={{ visibility: "visible", backgroundImage: `url("https://static.s-sfr.fr/assets/pictos/aide_40_noir.svg")` }}>                         <a href="https://assistance.sfr.fr/">Aide</a>                     </li>                     <li style={{ visibility: "visible", backgroundImage: `url("https://static.s-sfr.fr/assets/pictos/pin_40_noir.svg")` }}>                         <a href="https://boutique.sfr.fr/">Boutiques</a>                     </li>
                <li style={{ visibility: "visible", backgroundImage: `url("https://static.s-sfr.fr/assets/pictos/Handicap_40_noir.svg")` }}>
                    <a href="https://www.sfr.fr/handicap/">Handicap</a>                     </li>                  </span>             </ul>               <ul id="eTh-main" className="M">
            <a href="https://www.sfr.fr/" title="Accueil SFR" style={{ visibility: "visible", backgroundImage: `url("https://static.s-sfr.fr/assets/logos/SFR.svg")` }}></a>
            <li className="PAR hd"><a href="https://www.sfr.fr/">Accueil SFR</a></li>
            <li className="PRO"><a href="https://www.sfr.fr/pro/">Accueil SFR PRO</a></li>
            <input type="checkbox" id="eThM3" />                 <li className="PAR ho hf"><a href="https://www.sfr.fr/offre-internet">Offres Box</a></li>
            <div>
                <a href="https://www.sfr.fr/offre-internet"><p>Voir Offres Box</p></a>
                <ul className="MM4">
                    <li>
                        <ul>
                            <li><b>Offres</b></li>
                            <li>                                  
                                <a href="https://www.sfr.fr/offre-internet">Box internet</a>
                            </li>                              
                            <li>
                                <a href="https://www.sfr.fr/offre-internet/sfr-box4g">Box 4G+</a>
                            </li>
                            <li>
                                <a href="https://www.sfr.fr/offre-internet/internet-partout">Internet partout</a>
                            </li>
                            <li>
                                <a href="https://www.sfr.fr/options/internet-garanti">Internet garanti</a>
                            </li>
                            <li>
                                <a href="https://www.sfr.fr/offre-internet/options">Toutes les options</a>
                            </li>                             </ul>
                    </li>
                    <li>
                        <ul>
                            <li>
                                <b>Equipements</b>
                            </li>                                 <li>
                                <a href="https://www.sfr.fr/box-8/">SFR Box 8X</a>
                            </li>                                 <li>
                                <a href="https://www.sfr.fr/offre-internet/box-internet">Box et décodeurs</a>                                 </li>
                            <li>                                     <a href="https://www.sfr.fr/boxtv/televiseurs">Box + TV</a>
                            </li>                                 <li>                                     <a href="https://www.sfr.fr/box-console/playstation-5/">Box + PS5</a>                                 </li>
                            <li>                                     <a href="https://www.sfr.fr/boxtv/videoprojecteur-the-freestyle">Box + Projecteur</a>                                 </li>                                 <li>
                                <a href="https://www.sfr.fr/accessoires/maison-connectee-et-gaming">Accessoires Box</a>
                            </li>
                        </ul>                         </li>
                    <li>
                        <ul>
                            <li><b>Avantages SFR</b>
                            </li>
                            <li>  <a href="https://www.sfr.fr/reseau/carte-couverture-fibre-et-internet.html">Couverture réseau Internet et fibre</a></li>
                            <li><a href="https://www.sfr.fr/internet-mobile/sfr-family" data-hi="0">Avantages Box + Mobile</a></li>
                            <li><a href="https://www.sfr.fr/offre-internet/frais-resiliation">Changement d'opérateur</a>
                            </li>
                        </ul>                         </li>
                    <li>
                        <ul>
                            <li>
                                <b>Déjà client</b>

                            </li>                                 <li>
                                <a href="https://www.sfr.fr/routage/evoluer-mon-offre">Changer d'offre</a>
                            </li>
                            <li>
                                <a href="https://www.sfr.fr/offre-internet/demenagement">Déménagement Internet</a>
                            </li>
                            <li>
                                <a href="https://www.sfr.fr/espace-client/options/">Gérer vos options box&nbsp;</a>                                 </li>
                        </ul>
                    </li>
                </ul>
                <ul>
                    <li>
                        <a href="https://www.sfr.fr/boxtv/samsung-tv-au7105-43">Smart TV Samsung</a>
                    </li>
                    <li>
                        <a href="https://www.sfr.fr/boxtv/videoprojecteur-the-freestyle">Vidéoprojecteur Samsung</a>
                    </li>                         <li>
                        <a href="https://www.sfr.fr/offre-internet/fibre-optique">La Fibre de SFR</a>                         </li>
                    <li>
                        <a href="https://www.sfr.fr/tv-sfr/disneyplus-sfr-divertissement">Disney+</a>
                    </li>
                    <li>
                        <a href="https://www.sfr.fr/tv-sfr/netflix-sfr">Netflix</a>
                    </li>                     </ul>
            </div>
            <label htmlFor="eThM3"></label>
            <input type="checkbox" id="eThM4" />
            <li className="PAR ho">
                <a href="https://www.sfr.fr/offre-mobile">Forfaits et Téléphones</a>
            </li>                 <div>
                <a href="https://www.sfr.fr/offre-mobile">
                    <p>Voir Forfaits et Téléphones</p></a>
                <ul className="MM4"><li><ul>
                    <li><b>Offres</b></li>

                    <li><a href="https://www.sfr.fr/offre-mobile" data-hi="0">Forfaits Mobile</a></li>
                    <li><a href="https://www.sfr.fr/offre-mobile/decouvrir-la-5g">5G de SFR</a></li>
                    <li><a href="https://www.sfr.fr/offre-mobile/carte-prepayee">Carte prépayée</a></li>
                    <li><a href="https://www.sfr.fr/offre-mobile/options">Options mobile</a>
                    </li>                         <li>
                        <a href="https://www.sfr.fr/offre-mobile/international">International</a>
                    </li>
                </ul>
                </li>
                    <li>
                        <ul>
                            <li><b>Téléphones</b>
                            </li>
                            <li>
                                <a href="https://www.sfr.fr/offre-mobile/telephone-portable">Téléphones</a>
                            </li>
                            <li>
                                <a href="https://www.sfr.fr/offre-mobile/bons-plans">Bons plans mobile</a>
                            </li>
                            <li><a href="https://www.sfr.fr/offre-mobile/telephones/reconditionne">Téléphones reconditionnés</a></li>
                            <li>
                                <a href="https://www.sfr.fr/offre-mobile/telephones/sans-forfait">Téléphones sans forfait</a></li>
                            <li>
                                <a href="https://www.sfr.fr/accessoires/">Accessoires pour mobile à partir de 4,99€</a></li>                                 <li>
                                <a href="https://www.sfr.fr/accessoires/montres-et-bracelets-connectes">Montres connectées</a>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <ul>
                            <li>
                                <b>Avantages SFR</b>

                            </li>                                 <li>
                                <a href="https://www.sfr.fr/reseau/carte-couverture-reseau-mobile.html">Couverture réseau mobile 4G et 5G</a>
                            </li>
                            <li>
                                <a href="https://www.sfr.fr/internet-mobile/sfr-family" data-hi="0">Avantages Box + Mobile</a>                                 </li>

                            <li>                                     <a href="https://odr.sfr.fr/offres-remboursement/">Offres de remboursement</a>
                            </li>                                 <li>
                                <a href="https://www.sfr.fr/offre-mobile/reprise-mobile">Reprise mobile</a>                                 </li>
                        </ul>
                    </li>
                    <li>
                        <ul>
                            <li>                                     <b>Déjà client</b>
                            </li>
                            <li>

                                <a href="https://www.sfr.fr/offre-mobile?context=change&amp;parcours=offre">Changer d'offre</a>                                 </li>
                            <li>
                                <a href="https://www.sfr.fr/offre-mobile?context=change&amp;parcours=telephone">Changer de téléphone</a>
                            </li>                                 <li>
                                <a href="https://www.sfr.fr/espace-client/options/">Gérer vos options mobile</a>                                 </li>
                            <li>
                                <a href="https://www.sfr.fr/options/multisurf">Multisurf : SIM additionnelle</a>
                            </li>
                        </ul>
                    </li>
                </ul>
                <ul>
                    <li>

                        <a href="https://www.sfr.fr/offre-mobile/telephones/apple">iPhone</a>
                    </li>
                    <li>
                        <a href="https://www.sfr.fr/offre-mobile/telephones/samsung">Samsung Galaxy</a>
                    </li>
                    <li>
                        <a href="https://www.sfr.fr/offre-mobile/telephones/5g">Téléphones 5G</a>
                    </li>
                    <li>
                        <a href="https://www.sfr.fr/accessoires/montres-et-bracelets-connectes?bht&amp;fBrand=Apple%7C">Apple Watch Series 8</a>
                    </li>
                </ul>
            </div>
            <label htmlFor="eThM4"></label>
            <input type="checkbox" id="eThM5" />
            <li className="PAR ho">
                <a href="https://www.sfr.fr/internet-mobile">Box + Mobile</a>
            </li>
            <div>
                <a href="https://www.sfr.fr/internet-mobile"><p>Voir Box + Mobile</p></a>
                <ul className="MM3">
                    <li>
                        <ul>
                            <li>
                                <b>Offres</b>
                            </li>
                            <li>
                                <a href="https://www.sfr.fr/internet-mobile">Offres Box + Mobile</a>                                 </li>
                            <li>
                                <a href="https://www.sfr.fr/offre-internet/options">Options</a>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <ul>
                            <li>
                                <b>Avantages</b>
                            </li><li>

                                <a href="https://www.sfr.fr/internet-mobile/sfr-family">Avantages Box + Mobile</a>                                 </li>
                            <li>
                                <a href="https://www.sfr.fr/offre-internet/frais-resiliation">Changement d'opérateur</a>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <ul>
                            <li>
                                <b>Déjà client</b>
                            </li>
                            <li>
                                <a href="https://www.sfr.fr/offre-internet/demenagement">Déménagement</a>
                            </li>
                        </ul>
                    </li>
                </ul>
                <ul>
                    <li>
                        <a href="https://www.sfr.fr/internet-mobile/sfr-family">SFR FAMiLY!</a>
                    </li>
                </ul>
            </div>
            <label htmlFor="eThM5"></label>
            <input type="checkbox" id="eThM6" />

            <li className="PAR ho">
                <a href="https://www.sfr.fr/tv-sfr">TV</a>
            </li>
            <div>

                <a href="https://www.sfr.fr/tv-sfr"><p>Voir TV</p></a>
                <ul className="MM3">
                    <li>
                        <ul>
                            <li>
                                <b>Expérience TV</b>
                            </li><li>
                                <a href="https://www.sfr.fr/tv-sfr">Services TV&nbsp;</a>                                 </li>
                            <li>
                                <a href="https://www.sfr.fr/tv-sfr/toutes-les-chaines">Chaînes TV</a>
                            </li>
                            <li>
                                <a href="https://www.sfr.fr/boxtv/televiseurs">Offres Box + TV</a>
                            </li>
                            <li>
                                <a href="https://www.sfr.fr/tv-sfr/options">Bouquets TV et gaming</a>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <ul>
                            <li>
                                <b>Bouquets TV</b>
                            </li>
                            <li>

                                <a href="https://www.sfr.fr/tv-sfr/bouquets-sport">Sport</a>
                            </li>
                            <li>
                                <a href="https://www.sfr.fr/tv-sfr/bouquets-cinema-et-series">Cinéma et séries</a>
                            </li>                                 <li>
                                <a href="https://www.sfr.fr/tv-sfr/bouquets-divertissement-et-decouverte">Divertissement et découverte</a>
                            </li>
                            <li>

                                <a href="https://www.sfr.fr/tv-sfr/bouquets-jeunesse">Jeunesse</a>
                            </li>
                            <li>
                                <a href="https://www.sfr.fr/tv-sfr/bouquets-monde">Monde</a>
                            </li>
                            <li>
                                <a href="https://www.sfr.fr/tv-sfr/bouquets-musique">Musique</a>
                            </li>
                        </ul>
                    </li>

                    <li>
                        <ul>
                            <li>
                                <b>Déjà client</b>
                            </li><li>
                                <a href="https://www.sfr.fr/espace-client/options/">Souscrire une option</a>
                            </li>                        
                                 </ul>
                    </li>                
                         </ul>              
                                <ul>
                    <li>
                        <a href="https://www.sfr.fr/tv-sfr/disneyplus-sfr-divertissement">Disney+</a>                         </li>
                    <li>                             <a href="https://www.sfr.fr/tv-sfr/rmc-sport-eng">RMC Sport</a>
                    </li>                         <li>
                        <a href="https://www.sfr.fr/tv-sfr/netflix-sfr-divertissement">Netflix</a>                         </li>                         <li>
                        <a href="https://www.sfr.fr/boxtv/samsung-tv-au7105-43">BOX + TV 4K</a>
                    </li>
                    <li>
                        <a href="https://www.sfr.fr/canalplus/">CANAL+</a>
                    </li></ul>                 </div>
            <label htmlFor="eThM6"></label>
            <li className="PAR red"><a href="https://www.sfr.fr/offre-mobile/telephones/apple">iPhone 14 Pro</a></li>
            <li className="PRO hf"><a href="https://www.sfr.fr/offre-internet-pro/box">Offres Box</a></li>
            <li className="PRO"><a href="https://www.sfr.fr/forfait-mobile-pro/offres/forfait-mobile">Forfaits mobile</a></li>
            <li className="PRO"><a href="https://www.sfr.fr/forfait-mobile-pro/telephones/forfait-mobile">Téléphones</a></li>
            <li className="PRO"><a href="https://www.sfr.fr/pro/box-mobile/">Box + Mobile</a></li>
            <li className="PRO"><a href="https://www.sfr.fr/pro/contenus/">Options</a></li>                 <span>
                <li className="PAR P" style={{ visibility: "visible", backgroundImage: `url("https://static.s-sfr.fr/assets/pictos/Panier_40_noir.svg")` }}>
                    <label htmlFor="eTpa"><p>Panier</p></label>                     </li>
                <li style={{ visibility: "visible", backgroundImage: `url("https://static.s-sfr.fr/assets/pictos/mail_40_noir.svg")` }}>                        <a href="https://webmail.sfr.fr/main.html">Mail</a>
                </li>
                <li className="hE" style={{ visibility: "visible", backgroundImage: `url("https://static.s-sfr.fr/assets/pictos/Compte_40_noir.svg")` }}>
                    <label htmlFor="eThE">
                        <p>Espace Client</p>
                    </label>
                </li>
                <li className="hB" style={{ visibility: "visible", backgroundImage: `url("https://static.s-sfr.fr/assets/../media/hs-menu.svg")` }}>
                    <label htmlFor="eThB"><p>Menu</p></label>
                </li>
                <li className="hX" style={{ backgroundImage: `url("https://static.s-sfr.fr/assets/../media/hs-x.svg")` }}>

                    <label htmlFor="eThX"><p></p></label>
                </li>
            </span>
        </ul>
        <ul id="eTh-ec" className="E">
            <p>Identifiez-vous pour accéder à votre<br />espace client</p>
            <li className="CN C">Centre de notification</li>
            <li className="B D"><a href="https://www.sfr.fr/mon-espace-client/">Se connecter</a></li>
            <li className="B C"><a href="https://www.sfr.fr/mon-espace-client/">Accéder à l'espace client</a></li>
            <li><a href="https://assistance.sfr.fr/actes-urgence.html">Accès aux actes d'urgence</a></li>
            <li className="C"><a href="https://www.sfr.fr/routage/identifiant">Mots de passe et sécurité</a></li>
            <li className="C"><a href="https://www.sfr.fr/routage/gestionlignes">Rattacher / Retirer mes lignes</a></li>
            <li className="D"><a href="https://www.sfr.fr/suivi-commande/">Suivi de commande</a></li>
            <li className="C"><a href="https://espace-client.sfr.fr/suivre-ma-commande/authentification">Mes commandes</a></li>
            <li><a href="https://www.sfr.fr/offre-internet/demenagement">Déménagement</a></li>
            <li className="X C" style= {{backgroundImage: `url("https://static.s-sfr.fr/assets/pictos/power_40_noir.svg")`}}>
                <a href="https://www.sfr.fr/cas/logout?url=https://www.sfr.fr/">Se déconnecter</a></li>                   
                  <li className="N"></li>
        </ul>
        <div id="eTpaT"><br />Votre panier est vide</div>
        <label htmlFor="eThX"></label>
    </div>);
};
export default Header;
